<template lang="pug">
v-sheet.d-flex(height="600")
  v-navigation-drawer.h-100(:value="true" permanent)
    template(#prepend)
      v-list-item
        v-list-item-content
          v-list-item-title Подписанты
    v-list-item-group(v-model="selectedSign")
      v-list-item(
        v-for="(signature, idx) in signatures"
        :key="idx"
      )
        v-list-item-content
          v-list-item-title {{ signature.signData.commonName }}
  v-window.w-100.overflow-y-auto.scroll(
    v-model="selectedSign"
    vertical
  )
    v-window-item(v-for="(signature, idx) in signatures" :key="idx")
        v-progress-linear(
          v-if="loading"
          color="primary"
          indeterminate
        )
        v-list
          template(v-for="({ text, value }, idx) in signature.signDataFields")
            v-list-item(v-if="value" :key="idx")
              v-list-item-content.py-1
                v-list-item-title {{ text }}
                v-list-item-subtitle.word-break-normal  {{ value }}
        v-textarea.ml-4.mb-4(
          :value="signature.signature"
          hide-details
          label="Подпись"
          readonly
        )
        v-btn.ml-4.mb-5(
          :loading="loadingSig"
          @click="downloadSignatureFile(signature)"
        ) Скачать файл подписи
</template>

<script>

export default {
  name: 'ViewSignatures',
  props: {
    signatures: { type: Array, required: true },
  },
  data() {
    return {
      loadingSig: false,
      loading: false,
      selectedSign: null,
    };
  },
  computed: {
    inheritedClasses() {
      return this.$vnode.data.staticClass?.split(' ') || [];
    },
    readyForValidate() {
      return this.signatures.every((s) => s.file.base64);
    },
  },
  created() {
    this.validateSignatures();
  },
  methods: {
    async validateSignatures() {
      this.loading = true;
      const promises = this.signatures.map((s) => s.validate());
      Promise.all(promises)
        .then(
          () => {},
          (reason) => {
            this.$toasted.error(reason);
          },
        ).finally(() => { this.loading = false; });
    },
    async downloadSignatureFile(signature) {
      this.loadingSig = true;
      await signature.downloadSignatureFile();
      this.loadingSig = false;
    },
  },
};
</script>
